<template>
  <div class="layout-container">
    <header>
      <slot name="header"></slot>
    </header>
    <main>
      <slot name="main"></slot>
    </main>
    <footer>
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Layout",
  props: {
    config: Object,
  },
};
</script>

<style lang="scss" scoped>
.layout-container {
  display: flex;
  height: 100%;
  flex-direction: column;
}

header {
  flex-shrink: 0;
  z-index: 9;
}

main {
  flex-grow: 1;
  flex-shrink: 0;
}

footer {
  flex-shrink: 0;
}
</style>
